import { AxiosHeaders } from "axios";
import api from "./api";
import { clearLocalStorage, goTo, redirectOnMenu, returnCatalogId, setSelectedCard, setSelectedCatalog } from "../utilities/common.utilities";
import { getUserCards } from "./card.service";
import cardModel from "../static/card-model";
import { getAllCustomerInfo } from "./allCustomerInfo.service";
import { getCatalogs } from "./catalog.service";
import { getUserPoints } from "./points.service";
import { getPrivacyInfo } from "./privacy.service";
import { ManagePrivacyDataModel } from "../static/privacy.model";
import { getPharmacyInfoWithoutInterceptor } from "./pharmacy.service";

type LoginUser = {
    UserName: string;
    Password: string;
}

class LoginCodeError extends Error {

  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

export async function getUser(username: string, password: string) {
  try{

    const user: LoginUser = {
      UserName: username,
      Password: password
    };
  
    const headers: AxiosHeaders = new AxiosHeaders()
    headers.set('Content-Type', 'application/json');
    headers.set('Access-Control-Allow-Origin', '*');
    headers.set('Accept', 'application/json');
   await api.post('/v3/login', JSON.stringify(user), { headers: headers }).then(async data => {
    if(data?.data){
      localStorage.setItem("user", JSON.stringify(data.data));
      await getUserCards().then( async (cardData: cardModel) => {
        if(cardData.cards.length > 0){

          const groupCode = cardData.cards[0].groupId.toString();
          const storeCode = cardData.cards[0].mainStoreCode;
          const card = cardData.cards[0].cardNumber;
          
          setSelectedCard(card);

          // Per avere sempre il codice a barra della card, richiamo la 'cardFiltered' qui nella login
          getPharmacyInfoWithoutInterceptor(groupCode,storeCode,card);

          await getAllCustomerInfo(groupCode, storeCode, card).then(async allCustomerInfo => {
            await getCatalogs(groupCode, storeCode, card).then( async catalogs => {
              let lastCatalog: number = 0;
              if(catalogs?.length > 0){
                if(catalogs.length === 1){
                  lastCatalog = catalogs[0].catalogId;
                  // await setSelectedCatalog(lastCatalog.toString());
                  // return data.data;
                } else {
                  catalogs.map( (item:any) => {
                    if(item.catalogId > lastCatalog){
                      lastCatalog = item.catalogId;
                    }
                  });
                  // await setSelectedCatalog(lastCatalog.toString());
                  
                }
                
              } else {
                console.log("dev-info: non è presente nessun catalogo per questa carta");
                return;
              }
              setSelectedCatalog(lastCatalog.toString());

              await getUserPoints(groupCode, storeCode, card,lastCatalog.toString()).then(async points => {
                
                await getPrivacyInfo(groupCode, storeCode, card).then(privacy => {

                  // Se bisogna aggiornare i dati, reindirizzo sul componente che gestisce i consensi
                  if(privacy) {
                    if(privacy?.forcePrivacySet) {
                      let state: ManagePrivacyDataModel = {
                        pathname: '/login',
                        privacyInfo: privacy.privacyProfile,
                        forceUpdate: true,
                        storeName: '-'
                      }

                      localStorage.setItem('managePrivacyData', JSON.stringify(state))
                      goTo('/privacy');
                    }
                    // altrimenti reindirizzo in home
                    else {
                      goTo('/home');
                    }
                  }
                  else {
            
                    console.log("dev-info: non è presente nessun dato sul consenso della privacy");
        
                    throw new LoginCodeError('Non è presente nessun dato sul consenso della privacy', 500);
                    //return;
                  }

                })
                return data.data;
              }) 
            })   
          })  
      } else {
        //clearLocalStorage();
        //throw new LoginCodeError('Non è presente nessuna carta per questo account', 500);

        redirectOnMenu();
        
      }
    });
    } else {
      console.log("dev-info: "+JSON.stringify(data));
      return;
    }
    
   });

  } catch(err) {
    console.log(err);
    return err;
  }

  
};



